"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var classnames_1 = __importDefault(require("classnames"));
var Icon_1 = __importDefault(require("../../Icon"));
var types_1 = require("../types");
var consts_1 = require("../consts");
var styles_1 = require("./styles");
var Snack = function (_a) {
    var _b;
    var title = _a.title, message = _a.message, onDismiss = _a.onDismiss, buttonTitle = _a.buttonTitle, onButtonClick = _a.onButtonClick, _c = _a.type, type = _c === void 0 ? 'success' : _c, _d = _a.animationType, animationType = _d === void 0 ? types_1.EAnimationType.slide : _d, _e = _a.position, position = _e === void 0 ? 'topRight' : _e, isRemovalAnimated = _a.isRemovalAnimated, onMouseOver = _a.onMouseOver, onMouseOut = _a.onMouseOut;
    var formatMessage = (0, react_intl_1.useIntl)().formatMessage;
    var formattedTitle = title && typeof title === 'object' ? formatMessage(title) : title;
    var formattedMessage = message;
    if (message && !(0, react_1.isValidElement)(message) && typeof message !== 'string') {
        formattedMessage = formatMessage(message);
    }
    var formattedButtonTitle = buttonTitle && typeof buttonTitle === 'object' ? formatMessage(buttonTitle) : buttonTitle;
    return ((0, jsx_runtime_1.jsxs)(styles_1.Container, __assign({ animationType: animationType, position: position, className: (0, classnames_1.default)((_b = {},
            _b[type] = true,
            _b['remove-snack'] = isRemovalAnimated,
            _b)), onMouseOver: onMouseOver, onMouseOut: onMouseOut }, { children: [(0, jsx_runtime_1.jsx)(Icon_1.default, { name: "alert-circle-outline", size: "m" }), (0, jsx_runtime_1.jsxs)(styles_1.Wrapper, { children: [(0, jsx_runtime_1.jsxs)(styles_1.ContentWrapper, { children: [formattedTitle && ((0, jsx_runtime_1.jsx)(styles_1.Title, __assign({ "data-testid": "snack-title", bold: true }, { children: formattedTitle }))), formattedMessage && ((0, jsx_runtime_1.jsx)(styles_1.Message, __assign({ size: "sm", "data-testid": "snack-description" }, { children: formattedMessage }))), !!formattedButtonTitle && (0, jsx_runtime_1.jsx)(styles_1.ActionBtn, __assign({ onClick: onButtonClick }, { children: formattedButtonTitle }))] }), !!onDismiss && ((0, jsx_runtime_1.jsx)(styles_1.Dismiss, __assign({ onClick: onDismiss, "data-testid": consts_1.TEST_ID_SNACK_CLOSE }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { name: "close", size: "m" }) })))] })] })));
};
exports.default = (0, react_1.memo)(Snack);
